(() => {
  let previousState = '';
  let previousHtml = '';
  function updatePrice() {
    const price = document.querySelector('[data-custom-pricing]');
    if (!price || !window.productData?.variants) return;
    const info = price.closest('.product-info');
    const id = info?.querySelector('#bcpo-select')?.value || info?.querySelector('[name="id"]')?.value;
    const variant = window.productData.variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    const rate = (100 - Number(price.dataset.discountPercent || 0)) / 100;
    const addons = Array.from(info.querySelectorAll('.bcpo-checkboxes input[type="checkbox"]:checked'))
      .reduce((sum, input) => sum + Math.round((Number(input.dataset.price) || 0) * 100), 0);
    const saleCents = Math.round(variant.price * rate) + addons;
    const regularCents = Math.max(variant.price, variant.compare_at_price || 0) + addons;
    const currency = window.Shopify?.currency?.active || 'USD';
    const state = [id, saleCents, regularCents, currency].join(':');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(cents / 100) + ' ' + currency;
    const onSale = regularCents > saleCents;
    if (state !== previousState || price.dataset.totalCents !== String(saleCents) || price.innerHTML !== previousHtml) {
    price.dataset.totalCents = String(saleCents);
    price.innerHTML = `
      <price-list class="price-list price-list--product">
        <sale-price class="${onSale ? 'text-on-sale' : ''} h4">
          <span class="price--sale"><span class="transcy-money">${money(saleCents)}</span></span>
          <span class="price--original text-subdued line-through" style="margin-left:0.5rem;${onSale ? '' : 'display:none!important;'}">
            <span class="transcy-money">${money(regularCents)}</span>
          </span>
        </sale-price>
      </price-list>`;
    previousState = state;
    previousHtml = price.innerHTML;
    }
    const affirmMessages = info.querySelectorAll('.affirm-as-low-as');
    let refreshAffirm = false;
    affirmMessages.forEach(message => {
      if (message.getAttribute('data-amount') !== String(saleCents)) {
        message.setAttribute('data-amount', String(saleCents));
        refreshAffirm = true;
      }
    });
    if (refreshAffirm && window.affirm?.ui?.refresh) window.affirm.ui.refresh();
  }
  document.addEventListener('change', () => setTimeout(updatePrice, 0));
  setInterval(updatePrice, 200);
  updatePrice();
})();
